// If the filter has an id, but it is not this category's id, remove it from active filters
export function getFiltersForCategory({ activeFilters, categoryId }) {
    return Object.keys(activeFilters).reduce((all, curr) => {
        const items = activeFilters[curr].filter((item) => {
            // The full filter ID is in the format <categoryId:number>:<filterId:string>
            // If there is no colon, there is no category ID, so this filter should always apply
            if (item.id.indexOf(':') === -1)
                return true;
            // We just want the category ID segment
            const id = parseInt(item.id);
            // If there is no category ID in the filter ID string, this filter should always apply
            if (!id)
                return true;
            // Otherwise, only apply this filter if the category ID taken from the
            // full filter ID matches the category ID passed in (generally from the current route)
            return id.toString() === categoryId.toString();
        });
        return Object.assign({}, all, { [curr]: items });
    }, {});
}
//# sourceMappingURL=getFiltersForCategory.js.map